import { withTrailingSlash } from 'ufo'

export const usePage = () => {
  const page: Ref<Page | null> = useState<Page | null>('page', () => null)
  const template: Ref<string | null> = useState('template', () => null)
  const isWebsiteInited: Ref<boolean> = useState('isWebsiteInited', () => false)
  const envVariables = useRuntimeConfig();
  const { lang } = useLanguage()
  const { domain } = useSetup()
  const { t } = useI18n()

  // Dohvaćanje podataka za page s backenda
  async function get() {
    try {
      page.value = await useServerFetch('v2/pages/find/', {
        params: {
          html_path: withTrailingSlash(useRoute().path)
        }
      }) as Page

      template.value = page.value?.meta?.type?.split('.')[1].replace('Page', '') || null
      return page.value 
    } catch (e) {
      page.value = null
      console.dir(e)
    }
  }

  const head = computed(() => {
    return {
      htmlAttrs: {
        lang
      },
      link: [
        {
          rel: 'canonical',
          href: page?.value?.cannonical_url || `${envVariables?.public?.domain}${page.value?.sef || ''}`
        },
      ]
    }
  })

  const meta = computed(() => {
    const _meta = {
      title: t('pageTitle'),
      image: `${envVariables.public.domain}/resources/images/share.jpg`,
      description: t('pageDescription')
    }

    // Provjera da li postoji nešto na page-u što bi mogao biti meta tag
    if (page.value) {
      if (page.value?.image?.meta?.url) _meta.image = getFlareVersion(page.value.image, { width: 1200, height: 630, crop: 'fill' })

      if (page.value?.meta?.search_description) _meta.description = page.value.meta.search_description
      else if (page.value.lead) _meta.description = stripHTMLTags(page.value.lead)

      if (page.value?.meta?.seo_title) _meta.title = page.value.meta.seo_title
      else if (page.value.title) _meta.title = page.value.title
    }

    return {
      viewport: 'height=device-height, width=device-width, initial-scale=1.0, minimum-scale=1.0',
      title: _meta.title,
      ogTitle: _meta.title,
      description: _meta.description,
      ogDescription: _meta.description,
      ogImage: _meta.image,
      ogUrl: `${envVariables.public.domain}${page.value ? page.value.sef : ''}`,
      twitterCard: 'summary'
    }
  })

  return {
    isWebsiteInited,
    page,
    template,
    meta,
    head,
    get
  } 
}
